<template>
  <div class="home">
  
    <Reproductor msg="Lección #6" audio2="../mp3/SecundariaC/06SC.mp3" cover="../img/10.jpg" name="Secundaria C"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
